import { Node, NodeSpec } from 'prosemirror-model';
import { BaseNode } from './base/BaseNode';

export class Mention extends BaseNode {
  constructor() {
    super('mention');
  }

  get schema(): NodeSpec {
    const toPlainText = (node: Node) => `@${node.content?.content?.[0]?.text ?? 'user'}`;

    return {
      attrs: {
        modelId: { default: null },
      },
      context: 'text*',
      inline: true,
      marks: '',
      group: 'inline',
      atom: true,
      selectable: true,
      parseDOM: [
        {
          tag: 'span.mention',
          preserveWhitespace: true,
          priority: 100,
          getAttrs(dom: HTMLElement) {
            return {
              modelId: dom.dataset.id,
            };
          },
        },
      ],
      toDOM(node: Node) {
        return [
          'span',
          {
            class: 'mention',
            'data-id': node.attrs.modelId,
            contentEditable: 'false',
          },
        ];
      },
      leftMark: toPlainText,
    };
  }
}
